export const PensionFundsRoutes = {
    ROOT: "/pension-funds",
    PERSONAL_DATA: "/pension-funds/personal-data",
    NEW_PHONE: "/pension-funds/new-phone",
    NEW_ADDRESS: "/pension-funds/new-address",
    SUCCESS: "/pension-funds/success"
};



// WEBPACK FOOTER //
// ./src/components/pensionFunds/PensionFundsRoutes.ts